import { render } from "./AddEditItemModal.vue?vue&type=template&id=08d279c8&scoped=true"
import script from "./AddEditItemModal.vue?vue&type=script&lang=js"
export * from "./AddEditItemModal.vue?vue&type=script&lang=js"

import "./AddEditItemModal.vue?vue&type=style&index=0&id=08d279c8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d279c8"]])

export default __exports__